export default __webpack_public_path__ + "static/media/R.6938c172.svg";